import React from 'react'
import ProjectApi from '../../../api/Corporates/Projects'
import ProgramView from '../../../components/Project/Programs/ProgramsListView'
import useFetchList from '../../../elements/Hooks/useFetchList'

import useModalData from '../../../elements/Hooks/useModalData'

const api = new ProjectApi()
function ProgramViewCont() {
  const { list, fetching, fetch } = useFetchList(() => api.listByType('program'))
  const { list: listProject, fetching: fetchingProject, fetch: fetchProjects } = useFetchList(() =>
    api.listByType('project')
  )
  const {
    visible,
    modalType,
    object,
    submitting,
    setSubmitting,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
    submit,
  } = useModalData(api.createProgram, undefined, undefined, fetch)

  return (
    <ProgramView
      {...{
        visible,
        modalType,
        object,
        submitting,
        setSubmitting,
        formRef,
        onShow,
        onCancel,
        checkForm,
        update,
        submit,
        list,
        listProject,
        fetching,
        fetchingProject,
        fetch,
        fetchProjects,
      }}
    />
  )
}

export default ProgramViewCont
